import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, lead, children, testId }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white" data-testid={testId}>
      <header className="sticky top-0 z-30 bg-white/90 backdrop-blur-xl border-b border-slate-200">
        <div className="max-w-5xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 group" aria-label="Zur Startseite">
            <img
              src="/brand/xortec-logo.png"
              alt="Xortec"
              className="h-8 md:h-9 w-auto"
            />
          </Link>
          <Link
            to="/"
            data-testid="legal-back-home"
            className="inline-flex items-center gap-2 text-sm font-medium text-slate-700 hover:text-[#0055A4]"
          >
            <ArrowLeft className="h-4 w-4" /> Zurück zur Startseite
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 md:px-10 py-16 md:py-24">
        <p className="tag-line text-xs font-mono-tech uppercase tracking-[0.25em] text-[#0055A4] mb-6">
          Rechtliches
        </p>
        <h1 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight text-slate-900">
          {title}
        </h1>
        {lead && (
          <p className="mt-5 text-slate-600 text-base sm:text-lg leading-relaxed">
            {lead}
          </p>
        )}
        <div className="mt-12 prose prose-slate max-w-none prose-headings:font-display prose-headings:font-semibold prose-headings:text-slate-900 prose-h2:text-2xl prose-h2:mt-12 prose-h3:text-lg prose-a:text-[#0055A4] prose-a:no-underline hover:prose-a:underline prose-p:text-slate-600 prose-p:leading-relaxed prose-li:text-slate-600">
          {children}
        </div>
      </main>

      <footer className="border-t border-slate-200 py-10 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} Xortec GmbH ·{" "}
        <Link to="/impressum" className="hover:text-[#0055A4]">
          Impressum
        </Link>{" "}
        ·{" "}
        <Link to="/datenschutz" className="hover:text-[#0055A4]">
          Datenschutz
        </Link>
      </footer>
    </div>
  );
}
